// src/pages/VulnerabilityManager.js
import React from 'react';
import Layout from '../components/Layout';
import Chart from 'react-apexcharts';
import ComingSoon from '../components/ComingSoon';

function VulnerabilityManager() {
    // Fake data for the vulnerability table
    const vulnerabilities = [
        { name: 'Vulnerability 1', cve: 'CVE-2023-50918', severity: 'High', score: '7.3' },
        { name: 'Vulnerability 2', cve: 'CVE-2023-50919', severity: 'High', score: '8.3' },
        { name: 'Vulnerability 3', cve: 'CVE-2023-50920', severity: 'Medium', score: '4.6' },
        { name: 'Vulnerability 4', cve: 'CVE-2023-50921', severity: 'Medium', score: '3.2' },
        { name: 'Vulnerability 5', cve: 'CVE-2023-50922', severity: 'Medium', score: '3.8' },
    ];
    const lineChartOptions = {
        chart: {
            id: 'traffic-by-application',
            toolbar: {
                show: false
            }
        },
        xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun']
        },
        stroke: {
            curve: 'smooth'
        },
        dataLabels: {
            enabled: false
        },
        colors: ['#FF4560', '#00E396', '#008FFB']
    };

    const lineChartSeries = [
        {
            name: 'Proxmox',
            data: [31, 40, 28, 51, 42, 109]
        },
        {
            name: 'Minecraft',
            data: [11, 32, 45, 32, 34, 52]
        },
        {
            name: 'Speedtest.org',
            data: [15, 11, 32, 18, 9, 24]
        }
    ];   

    return (
        <Layout>
            <ComingSoon>
            <div className="p-8 h-full">
                <h1 className="text-4xl font-bold text-white mb-8">Vulnerability Manager</h1>
                
                <div className="flex flex-wrap -mx-2 mb-4">
  {/* Risk Assessment Box */}
  <div className="w-full lg:w-1/2 px-2">
    <div className="bg-dark-card rounded-lg p-6 flex flex-col justify-between" style={{ height: '100%' }}> {/* Use flex to distribute space */}
      <h2 className="text-lg text-white mb-4">Risk Assessment (%)</h2>
      <Chart options={lineChartOptions} series={lineChartSeries} type="line" height="200" />
    </div>
  </div>

  {/* Vulnerability Details Box */}
  <div className="w-full lg:w-1/2 px-2">
    <div className="bg-dark-card rounded-lg p-6 flex flex-col justify-between" style={{ height: '100%' }}> {/* Use flex to distribute space */}
      <h2 className="text-lg text-white mb-4">Vulnerability Details</h2>
      <div className="grid grid-cols-4 gap-4">
        {/* Replace the following with actual components or styled divs */}
        <div className="bg-blue-600 p-4 rounded-lg">
          <p className="text-2xl text-white font-bold">8</p>
          <p className="text-white">Low</p>
        </div>
        <div className="bg-yellow-400 p-4 rounded-lg">
          <p className="text-2xl text-white font-bold">4</p>
          <p className="text-white">Medium</p>
        </div>
        <div className="bg-red-600 p-4 rounded-lg">
          <p className="text-2xl text-white font-bold">2</p>
          <p className="text-white">High</p>
        </div>
        <div className="bg-red-800 p-4 rounded-lg">
          <p className="text-2xl text-white font-bold">0</p>
          <p className="text-white">Urgent</p>
        </div>
      </div>
      <div className="text-sm text-gray-400 mt-4">
        <p>Last Quick Check: NOV 16, 2023 @ 6:36PM EST</p>
        <p>Last Through Scan: NOV 15, 2023 @ 3:45AM EST</p>
      </div>
    </div>
  </div>
</div>


                {/* Vulnerability Table */}
                <div className="bg-dark-card rounded-lg shadow-md p-4 text-white">
                    <table className="w-full">
                        <thead>
                            <tr className="text-xs font-semibold tracking-wide text-left text-white uppercase border-b border-custom-gray">
                                <th className="px-4 py-3">Vulnerability Name</th>
                                <th className="px-4 py-3">CVE</th>
                                <th className="px-4 py-3">Severity</th>
                                <th className="px-4 py-3">CVSS3 Score</th>
                                <th className="px-4 py-3">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="bg-dark-card">
                            {vulnerabilities.map((vulnerability, index) => (
                                <tr key={index} className="border-b border-custom-gray">
                                    <td className="px-4 py-3">{vulnerability.name}</td>
                                    <td className="px-4 py-3">{vulnerability.cve}</td>
                                    <td className="px-4 py-3">{vulnerability.severity}</td>
                                    <td className="px-4 py-3">{vulnerability.score}</td>
                                    <td className="px-4 py-3">
                                        <button className="text-blue-600 hover:text-blue-900">
                                            Learn More
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            </ComingSoon>
        </Layout>
    );
}

export default VulnerabilityManager;